import {
  GET_EMAIL_PREFERENCES,
  GET_EMAIL_PREFERENCES_SUCCESS,
  GET_EMAIL_PREFERENCES_ERROR,
  UPDATE_EMAIL_PREFERENCES,
  UPDATE_EMAIL_PREFERENCES_SUCCESS,
  UPDATE_EMAIL_PREFERENCES_ERROR,
} from "./actionTypes";

const initialState = {
  loading: false,
  saving: false,
  preferences: null,
  email: "",
  error: null,
};

const manageNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_PREFERENCES:
      return { ...state, loading: true, error: null };
    case GET_EMAIL_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: false,
        preferences: action.payload?.preferences ?? null,
        email: action.payload?.email ?? "",
      };
    case GET_EMAIL_PREFERENCES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload || "Unable to load your preferences.",
      };
    case UPDATE_EMAIL_PREFERENCES:
      return { ...state, saving: true, error: null };
    case UPDATE_EMAIL_PREFERENCES_SUCCESS:
      return {
        ...state,
        saving: false,
        preferences: action.payload?.preferences ?? state.preferences,
        error: null,
      };
    case UPDATE_EMAIL_PREFERENCES_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload || "Unable to save your preferences.",
      };
    default:
      return state;
  }
};

export default manageNotificationsReducer;
